import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const Terms: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>Terms & Conditions</Typography>
      <Typography variant="subtitle2" sx={{ mb: 4, color: 'text.secondary' }}>Effective Date: 13-01-2025</Typography>

      <Typography paragraph>Welcome to Amrutha Kalasam! These terms and conditions govern your use of our website and services. By using this site and its services, you agree to comply with the following terms. Please read them carefully.</Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>1. Services Provided</Typography>
        <Typography paragraph>Amrutha Kalasam offers astrology consultation services, including but not limited to, online consultations, personal readings, and related services.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>2. Booking & Payment</Typography>
        <Typography component="div" sx={{ mb: 2 }}>
          <ul style={{ marginTop: 0, paddingLeft: '1.2rem' }}>
            <li>All bookings must be made through the website or by direct consultation with our team.</li>
            <li>Payments for services are due at the time of booking.</li>
            <li>Prices for services are subject to change at our discretion.</li>
            <li>Once a booking is confirmed, you will receive an email with the booking details.</li>
          </ul>
        </Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>3. Customer Responsibilities</Typography>
        <Typography paragraph>You are responsible for providing accurate information during booking. You must be at the scheduled location or online at the agreed time for your consultation.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>4. Intellectual Property</Typography>
        <Typography paragraph>All content on the Amrutha Kalasam website, including text, images, logos, and designs, are the property of Amrutha Kalasam and are protected by copyright law.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>5. Liability</Typography>
        <Typography paragraph>While we strive to provide accurate and helpful services, Amrutha Kalasam is not responsible for any personal, financial, or other loss resulting from the use of our services.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>6. Privacy Policy</Typography>
        <Typography paragraph>For more information on how we collect, use, and protect your personal information, please refer to our Privacy Policy.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>7. Governing Law</Typography>
        <Typography paragraph>These terms and conditions are governed by the laws of India. Any disputes will be subject to the jurisdiction of Hyderabad, Telangana.</Typography>

        <Typography variant="h5" sx={{ mb: 1 }}>8. Contact Information</Typography>
        <Typography paragraph>If you have any questions about our Terms and Conditions, please contact us at:</Typography>
        <Typography paragraph>Email: amruthakalasamastrology@gmail.com</Typography>
        <Typography paragraph>Address: 337 1, Huda Sai Nagar Community Hall, H No 5 4, Kamala Nagar Rd, Near Kamal Nagar, Kamala Nagar, Hyderabad, Telangana-500070</Typography>
      </Box>

      <Divider sx={{ my: 6 }} />
      <Typography variant="body2" color="text.secondary">
        © 2024 Amruthakalasam. All rights reserved.
      </Typography>
    </Container>
  );
};

export default Terms;
